import { FormlyFieldConfig } from 'ng-formly';
export const formtemplateFields: Array<FormlyFieldConfig> = [
    {
        type: 'repeatedsection',
        key: 'charts',
        className: 'row',
        fieldArray: {

            templateOptions: {
                btnText: 'Add Row',
            },
            fieldGroup: [
                {
                    type: 'input-field',
                    key: 'name',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'text',
                        label: 'Chart Name',
                        required: true,
                    },
                },
                {
                    type: 'input-field',
                    key: 'label',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'text',
                        label: 'Chart Widget Label',
                        required: true,
                    },
                },
                {
                    key: 'height',
                    type: 'input-field',
                    className: 'col-md-4',
                    defaultValue: 500,
                    templateOptions: {
                        type: 'text',
                        label: 'Height in px',
                        required: true,
                        description: 'Height in px'
                    }
                },
                {
                    key: 'options',
                    type: 'textarea-field',
                    className: 'col-md-12',
                    templateOptions: {
                        label: 'Chart Options JSON',
                        required: true,
                        description: 'Chart Options',
                        rows: 20
                    }
                }

            ]
        }

    }

];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/formtemplate.ts